module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Promotions/general-promotion-list/gen-pro-list-grid/gen-pro-list-grid.component.css
// module id = ./src/app/hrms/Promotions/general-promotion-list/gen-pro-list-grid/gen-pro-list-grid.component.css
// module chunks = main